const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (Object.prototype.toString.call(value) !== '[object Object]') {
    return false
  }

  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

const toSnakeCaseKey = (value: string) =>
  value
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toLowerCase()

const toCamelCaseKey = (value: string) => {
  // 无下划线/连字符时保持原样，避免已是 camelCase 的 partCount 被 toLowerCase 成 partcount
  if (!/[_-\s]/.test(value)) {
    return value
  }
  return value.toLowerCase().replace(/[_-\s]+([a-z0-9])/g, (_, char: string) => char.toUpperCase())
}

const transformCase = <T>(input: T, keyTransformer: (key: string) => string): T => {
  if (Array.isArray(input)) {
    return input.map((item) => transformCase(item, keyTransformer)) as T
  }

  if (!isPlainObject(input)) {
    return input
  }

  return Object.entries(input).reduce(
    (acc, [key, value]) => {
      acc[keyTransformer(key)] = transformCase(value, keyTransformer)
      return acc
    },
    {} as Record<string, unknown>,
  ) as T
}

export const toSnakeCase = (value: string) => toSnakeCaseKey(value)

export const toCamelCase = (value: string) => toCamelCaseKey(value)

export const keysToSnakeCase = <T>(input: T): T => transformCase(input, toSnakeCaseKey)

export const keysToCamelCase = <T>(input: T): T => transformCase(input, toCamelCaseKey)
